import React from "react";

const IronIcon = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      className={className}
    >
      <path
        d="M3.95374 2.06372C4.91649 0.999621 6.64224 1.07259 8.1344 1.74634C10.0981 2.63314 11.1808 3.16125 13.0123 4.28052C14.5488 5.21944 16.1143 6.27317 16.817 7.38403C17.1958 7.7852 17.9911 9.00583 18.1432 10.678C18.2952 12.3501 18.2065 15.0907 18.1432 16.2522H17.8834V20.0002H16.6158V16.2522H16.3698L15.9899 10.8684C15.9731 10.5495 15.7583 9.97649 15.0856 9.75513C12.4233 10.1296 7.79574 10.1334 5.03088 10.0452C4.08071 10.0452 1.51704 10.0445 1.67346 7.38403C1.80015 5.23059 2.75036 3.39387 3.95374 2.06372Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default IronIcon;
